module.exports = __webpack_public_path__ + "static/grey2-4d2debfe9c9bd06b61e1d9d8249cb943.png";